<template>
  <div>
    <!-- <header>
      <Header msg="Header" />
      <div class="titlebar">
        <div class="container">
          <a href="javascript:">
            <router-link
              :to="{
                path: this.$router.currentRoute.meta.backTo,
                query: this.$router.currentRoute.query,
              }"
            >
              <i
                v-if="$router.currentRoute.meta.backTo"
                class="icon-arrow-left"
              ></i>
            </router-link>
          </a>
          訂單編號：{{ order.orderId }}
        </div>
      </div>
    </header> -->
    <main>
      <div v-if="loading" class="loading_area flex_center">
        <div class="loader"></div>
        <div>loading..</div>
      </div>

      <section class="order_detail">
        <div class="container flex_center">
          <!-- 取餐編號框框設計 -->
          <!-- 如果是line的版本，看到明細頁一定是付款完了，只差有沒有成功notify -->

          <div
            v-if="
              !order.orderStatus || (!order.isConfirmed && order.paymentStatus === 'payment_failed')
            "
            class="pick_number none"
          >
            訂單<br />尚未成立
          </div>
          <!-- <div
            v-if="
              !order.orderStatus &&
                !(type === 'line' && $router.currentRoute.query.token)
            "
            class="pick_number none"
          >
            訂單<br />尚未成立
          </div> -->
          <div
            v-else-if="
              (order.orderStatus ||
                (type === 'line' && $router.currentRoute.query.token)) &&
                order.shopCategory !== 'retail' &&
                order.partnerOrderId
            "
            :class="['pick_number', cssMap[order.mealType]]"
          >
            {{ mealTypeMap[order.mealType] }}<br />{{
              order.mealType === "eat_in" ? "桌號" : "取餐編號"
            }}
            <b>{{
              order.mealType === "eat_in"
                ? order.tableNumber
                : order.orderNumber /*order.partnerOrderId.slice(-4)*/
            }}</b>
          </div>
          <div
            v-else-if="
              (order.orderStatus ||
                (type === 'line' && $router.currentRoute.query.token)) &&
                order.shopCategory !== 'retail'
            "
            :class="['pick_number', cssMap[order.mealType]]"
          >
            {{ mealTypeMap[order.mealType] }}<br />取餐編號
            <b>{{ order.orderNumber }}</b>
          </div>
          <div
            v-else-if="
              order.orderStatus ||
                (type === 'line' && $router.currentRoute.query.token)
            "
            :class="['pick_number', cssMap[order.mealType]]"
          >
            {{ mealTypeMap[order.mealType] }}<br />領取編號
            <b>{{ order.orderNumber }}</b>
          </div>

          <div class="info">
            <div class="name">{{ order.shopName }}</div>
            <div
              v-if="order.shopCategory !== 'retail' && order.orderStatus"
              class="time"
            >
              下單時間：{{ order.orderTime }}
              <br />
              取餐時間：{{ order.takeMealTime }}
              
              <!-- 為了讓Lafresh前結流程也可運作 -->
              <span v-if="(order.orderStatus || (type === 'line' && order.paymentType === 'cash')) && order.shopCategory !== 'retail' && (order.mealType == 'eat_in' || order.mealType == 'to_go') && order.partnerOrderId"><br />取餐編號：{{order.orderNumber}}</span>
            </div>
          </div>

          <!-- <div
            v-if="
              order.orderStatus &&
                order.shopCategory !== 'retail' &&
                (order.mealType == 'eat_in' || order.mealType == 'to_go') &&
                order.partnerOrderId
            "
            class="barcode"
          > -->
          <div
            v-if="
              order.orderStatus &&
                order.shopCategory !== 'retail' &&
                order.partnerOrderId
            "
            class="barcode"
          >
            <img
              @error="showPartnerIdText = true"
              :src="
                'https://tools.iiot.io/barcode/code128?backgroundColor=ffffff&text=' +
                  order.partnerOrderId
              "
            />
            {{ showPartnerIdText ? order.partnerOrderId : "" }}
          </div>

          <!-- 提醒文字 -->
          <!-- 訂單查詢無狀態，顯示尚未完成付款資訊 -->
          <!-- <div v-if="!order.orderStatus && type !== 'line'" class="alert"> -->
          <div v-if="!order.orderStatus" class="alert">
            / 付款完成後將成立訂單 /
          </div>

          <!-- 訂單確認頁面現金無狀態 -->
          <!-- 其餘有狀態 -->
          <!-- 顯示對應資訊 -->
          <div
            v-else-if="
              (order.orderStatus ||
                (type === 'line' && order.paymentType === 'cash')) &&
                order.shopCategory !== 'retail' &&
                (order.mealType == 'eat_in' || order.mealType == 'to_go') &&
                order.partnerOrderId
            "
            class="alert"
          >
            / 請告知店家{{ order.mealType === "eat_in" ? "桌號" : "取餐編號" }}
            {{
              order.mealType === "eat_in"
                ? order.tableNumber
                : order.orderNumber/*order.partnerOrderId.slice(-4)*/
            }}
            /
          </div>
          <div
            v-else-if="
              (order.orderStatus ||
                (type === 'line' && order.paymentType === 'cash')) &&
                order.shopCategory !== 'retail' &&
                (order.mealType == 'eat_in' || order.mealType == 'to_go')
            "
            class="alert"
          >
            / 請告知店家取餐編號取餐 /
          </div>
          <div
            v-else-if="
              (order.orderStatus ||
                (type === 'line' && order.paymentType === 'cash')) &&
                order.shopCategory == 'retail' &&
                order.mealType == 'to_go'
            "
            class="alert"
          >
            / 請告知店家領取編號取貨 /
          </div>

          <!-- 訂單確認頁面無狀態，非現金付款 -->
          <!-- 顯示請等待資訊 -->
          <!-- <div v-else-if="!order.orderStatus && type === 'line'" class="alert">
            /
            {{
              order.paymentType !== "cash" &&
              !order.isConfirmed &&
              !order.isPaymentTimeout &&
              $router.currentRoute.query.token
                ? "線上付款更新訂單狀態需5分鐘左右，請稍候再進入查詢，謝謝！"
                : "付款完成後將成立訂單"
            }}
            /

          </div> -->
        </div>
      </section>
      <!-- 如果有openExternalBrowser=1，應該是從oa打開的，先暫時這樣判斷 -->
      <!-- TODO: 失敗過一次的再次付款，轉圈圈都會直接被停掉...因為判斷不出來是否retry，需要去移除firebase的狀態才行 -->
      <div v-if="((!order.orderStatus && type === 'line') && !(order.orderStatus === 'unknown' && order.paymentStatus === 'payment_failed' && type === 'line')) && !order.isConfirmed && !$router.currentRoute.query.openExternalBrowser" class="loading_area flex_center">
        <div class="loader"></div>
        <div>付款作業處理中<br>請勿關閉視窗..</div>  
      </div>

      <section class="order_detail">
        <div
          class="container"
          v-if="
            order.orderStatus &&
              order.orderStatus !== 'cancelled' &&
              order.orderStatus !== 'rejected' &&
              !(order.paymentStatus === 'payment_failed' && !order.isConfirmed)
          "
        >
          <div class="title">訂單狀態</div>
          <!--<div
            class="line"
          ></div>-->
          <div class="order_status">
            <span
              v-for="(step, index) in statusSteps[acceptType][order.mealType]"
              :key="index"
              :class="[order.stepStatus == step ? 'active' : '']"
              >{{ variables.sLabel[step] }}</span
            >
          </div>
        </div>
        <div
          class="container"
          v-else-if="
            order.orderStatus == 'cancelled' ||
              order.orderStatus == 'rejected' ||
              order.isCancelled == true
          "
        >
          <div class="title">
            訂單狀態
            <span class="order_status end cancel">訂單已取消</span>
          </div>
        </div>
        <div class="container" v-else-if="!order.isConfirmed && order.paymentStatus === 'payment_failed'">
          <div class="title">
            訂單狀態
            <span class="order_status end">訂單付款未完成</span>
          </div>
        </div>
        <div class="container" v-else-if="order.isConfirmed === 0">
          <div class="title">
            訂單狀態
            <span class="order_status end">訂單未付款</span>
          </div>
        </div>
        <div class="container" v-else>
          <div class="title">
            訂單狀態
            <span class="order_status end">等待付款</span>
          </div>
        </div>
      </section>

      <section class="order_detail">
        <div class="container">
          <div class="title">
            付款狀態
            <div class="iconbar">
              <div class="pay">
                <i :class="variables.payTypeIcon[order.paymentType]"></i>
                <!-- <i class="icon_linepay"></i> -->
                <!--<i class="icon_googlepay"></i>
                        <i class="icon_applepay"></i>
                        <i class="icon_creditcard"></i>
                <i class="icon_cash"></i>-->
                {{
                  // order.paymentType === "cash" ? "現場付款" : order.isConfirmed ? "已付款" : order.isPaymentTimeout ? "未完成付款" : "尚未付款"
                  order.paymentType === "cash" ? 
                    "現場付款" : order.isConfirmed === 1 ? 
                      "已付款" : order.isPaymentTimeout ? 
                        (order.paymentStatus === 'payment_failed' ? "付款失敗" : "未完成付款") : order.isConfirmed === 0 ? 
                            "尚未付款" : "等待付款"
                }}
              </div>
            </div>
          </div>
          <div class="flex_center payment" v-if="
                order.paymentType !== 'cash' &&
                  !order.isConfirmed &&
                  order.paymentUrl &&
                  !order.isPaymentTimeout
              ">
            <!-- <button v-if="!order.isCancelled" type="button" class="cancel" onclick>取消訂單</button> -->

            <button
              type="button"
              class="gotopay"
              v-on:click="openLink(order.paymentUrl)"
            >
              前往付款
            </button>
            <!-- 先暫時隱藏 -->
            <!-- <button
              v-if="menuUrl"
              type="button"
              class="gotopay"
              v-on:click="openMenu(order.orderId)"
            >
              再次下單
            </button> -->
          </div>
          <div class="flex_center payment" v-if="
                order.paymentType !== 'cash' &&
                  !order.isConfirmed &&
                  order.paymentUrl &&
                  !order.isPaymentTimeout
              ">
            <div class="timer">付款連結即將在 {{order.paymentDue}} 失效</div>
          </div>
        </div>
      </section>

      <section class="order_detail">
        <div class="container">
          <div class="title">
            訂購明細
            <div class="total">
              總計 $
              <b>{{ order.orderAmount }}</b>
            </div>

            <!-- 揪團訂單才顯示 -->
            <!-- 揪團訂單才顯示 -->
            <a
              v-if="order.groupOrderData && !isOpenAll"
              class="open-btn"
              v-on:click="openAll()"
              style="display:block;"
              ><i class="icon-add"></i> 全部展開</a
            >
            <a
              v-if="order.groupOrderData && isOpenAll"
              class="close-btn"
              v-on:click="closeAll()"
              style="display:block;"
              ><b>－</b> 全部收合</a
            >
          </div>

          <table v-if="!order.groupOrderData" class="order_detail_list">
            <tr>
              <th>商品</th>
              <th>數量</th>
              <th>小計</th>
            </tr>

            <tr v-if="order" v-for="(product, index) in order.products" :key="index">
              <td>{{ product.name }}
              <div v-if="product.priceStr" class="pickup_next">{{product.priceStr}}</div>
              </td>
              <td>{{ product.qty }}</td>
              <td>
                $
                <b>{{ product.price ? (product.price * product.qty).toFixed(2) : 0 }}</b>
              </td>
            </tr>
          </table>

          <div
            v-for="(gOrder, gIndex) in order.groupOrderData"
            :key="gIndex"
            class="groupbuy_list"
          >
            <ul
              class="member_order flex_center"
              v-on:click="toggleDetail(gOrder)"
            >
              <li class="name">{{ gOrder.name }}</li>
              <li class="qty">{{ gOrder.qty }}項</li>
              <li class="money">
                $<b>{{ (parseFloat(gOrder.productAmount) + parseFloat(gOrder.addonAmount)).toFixed(2) }}</b>
              </li>
              <li class="toggle">
                <a><i class="icon-arrow-down"></i></a>
              </li>
            </ul>
            <!-- <div v-if="!gOrder.openDetail"> -->
            <table  v-if="gOrder.openDetail" class="order_detail_list" style="display:table">
              <caption>
                下單時間：{{
                  gOrder.createdTime
                }}
                <!-- <div class="kcal">總卡路里：1000kcal</div> -->
              </caption>
              <tr>
                <th>商品</th>
                <th>數量</th>
                <!-- <th>卡路里</th> -->
                <th>小計</th>
              </tr>
              <tr v-for="(item, itemId) in gOrder.content" :key="itemId">
                <td>{{ `${item.productName}${item.addonStr ? '(' + item.addonStr + ')' : ''}` }}</td>
                <td>{{ item.qty }}</td>
                <!-- <td>500</td> -->
                <td>
                  $<b>{{ ((item.productAmount + item.addonAmt) * item.qty).toFixed(2) }}</b>
                </td>
              </tr>
              <tr v-if="gOrder.comment">
                <td colspan="4" class="note">
                  給團長的話：{{ gOrder.comment }}
                </td>
              </tr>
            </table>
            <!-- </div> -->
          </div>

          <ul class="calculate">
            <!-- 整單加購 -->
            <li
              class="calculate_list"
              v-if="order.orderAddonData && order.orderAddonData.name"
            >
              <span>{{ order.orderAddonData.name }}</span>
              <span class="price"
                >$<b>{{ order.orderAddonData.amount }}</b></span
              >
            </li>

            <!-- <li class="calculate_list">
              <span>服務費(10%)</span>
              <span class="price">$<b>100</b></span>
            </li> -->

            <li v-if="order.deliveryFee" class="calculate_list">
              <span>運費</span>
              <span class="price"
                >$<b>{{ order.deliveryFee }}</b></span
              >
            </li>

            <li
              v-if="order.shopCoveredFee"
              class="calculate_list discount"
            >
              <span>店家負擔運費</span>
              <span class="price"
                >-$<b>{{ order.shopCoveredFee }}</b></span
              >
            </li>

            <li v-if="order.discount" class="calculate_list discount">
              <span>折扣</span>
              <span class="price"
                >-$<b>{{ order.discount }}</b></span
              >
            </li>

            <li v-if="order.qcMoney" class="calculate_list discount">
              <span><i class="icon-point">$</i>快金折抵</span>
              <span class="price"
                >-$<b>{{ order.qcMoney }}</b></span
              >
            </li>

            <li v-if="order.qpointsValue" class="calculate_list discount">
              <span><i class="icon-point">$</i>台東金幣折抵</span>
              <span class="price"
                >-$<b>{{ order.qpointsValue }}</b></span
              >
            </li>

            <!-- <li class="calculate_list discount">
              <span><i class="icon-coupon"></i>優惠券折抵</span>
              <span class="price">-$<b>1</b></span>
            </li> -->
          </ul>

          <!-- <div class="total">
            總計 $
            <b>{{ order.detail.amount }}</b>
          </div> -->

          <div class="totalbar">
            總計 <b>{{ orderQty }}</b
            >項 / 共
            <span class="price"
              >$<b>{{ order.orderAmount || 0 }}</b></span
            >
          </div>
          <!-- 訂單完成不能直接跳到LINE內，只有在LINE查詢的才能跳settings -->
          <div
            v-if="
              order.pointName &&
                order.points &&
                userId &&
                !$router.currentRoute.query.token
            "
            class="getpoint flex_center"
          >
            <i class="icon-lion"></i> 獲得{{ order.pointName }}
            <b>{{ order.points }}</b> 點
            <a
              v-on:click="gotoPoints(order.pointVendor, order.pointMemberPhone)"
              class="search flex_center"
              >查詢 <i class="icon-arrow-right"></i
            ></a>
          </div>
          <div
            v-else-if="order.pointName && order.points"
            class="getpoint flex_center"
          >
            <i class="icon-lion"></i> 獲得{{ order.pointName }}
            <b>{{ order.points }}</b> 點
            <a
              v-on:click="gotoPoints(order.pointVendor, order.pointMemberPhone)"
              class="search flex_center"
              >查詢 <i class="icon-arrow-right"></i
            ></a>
          </div>
          <div
            v-else-if="
              order.pointName && order.qcExchangeMemberId && !order.points
            "
            class="getpoint flex_center"
          >
            <i class="icon-lion"></i> {{ order.pointDesc }}
            <a
              v-on:click="gotoPoints(order.pointVendor, order.userPhone)"
              class="search flex_center"
              >查詢 <i class="icon-arrow-right"></i
            ></a>
          </div>
          <!-- <div class="total">
            總計 <b>{{ orderQty }}</b
            >項 / 共$<b>{{ order.detail.amount }}</b>
          </div> -->
          <p>
            <b>備註：</b>
            <span>{{ order.comments || order.comment }}</span>
          </p>
        </div>
      </section>

      <section class="order_detail">
        <div class="container">
          <div class="title">店家資訊</div>
          <p>
            <b>店家名稱：</b>
            <span>{{ order.shopName }}</span>
          </p>
          <p>
            <b>店家地址：</b>
            <a
              target="_blank"
              v-on:click="
                openLink(
                  'https://www.google.com/maps/search/?api=1&query=' +
                    encodeURI(order.shopAddress)
                )
              "
            >
              <i class="icon-location"></i>
              {{ order.shopAddress }}
            </a>
          </p>
          <!-- <p class="tel">
            <b>店家電話：</b>
            <a :href="'tel:' + order.detail.shopPhone">{{
              order.detail.shopPhone
            }}</a>
          </p> -->
        </div>
      </section>

      <section class="order_detail">
        <div class="container">
          <div class="title">訂購資訊</div>
          <!-- <p>
            <b>訂購人：</b>
            <span>許倩</span>
          </p>-->
          <p class="tel">
            <b>訂購人電話：</b>
            <span>{{ order.userPhone }}</span>
          </p>
          <p v-if="order.mealType === 'delivery'">
            <b>外送地址：</b>
            <span>{{ order.deliveryAddress }}</span>
          </p>
        </div>
      </section>
    </main>
    <div
      v-if="showAd && showAd[0]"
      :class="['notify_fixed', type === 'portal' ? '' : 'ad_bottom0']"
    >
      <div class="container">
        <!-- 綁定line notify -->

        <a class="pc" target="_blank" :href="showAd[0].linkUrl">
          <img :src="showAd[0].imgUrl" />
        </a>
        <a class="mobile" target="_blank" :href="showAd[0].linkUrl">
          <img :src="showAd[0].imgUrl" />
        </a>
        <!-- <a class="mobile" target="_blank" :href="showAd[0].linkUrl">
          <img :src="showAd[0].imgUrl" />
        </a> -->

        <!-- 加店家line好友 -->
        <!-- <a href="#"><img src="images/line_addfriend.png"></a> -->
      </div>
    </div>
    <div
      v-if="!(showAd && showAd[0]) && showSuggestionLink"
      :class="['notify_fixed', type === 'portal' ? '' : 'to_bottom']"
    >
      <div class="container">
        <!-- 綁定line notify -->

        <a v-on:click="goToPage(suggestionLink[type].path)">
          <img :src="suggestionLink[type].img" />
        </a>

        <!-- 加店家line好友 -->
        <!-- <a href="#"><img src="images/line_addfriend.png"></a> -->
      </div>
    </div>
  </div>
</template>

<script>
// Guide:
// import './'  // 同一層目錄開始找
// import '../' // 上一層目錄開始找
// import '@/'  // src目錄下開始找
// import ''    // 直接打名稱則是node_modules

// @ is an alias to /src
import Header from "@/components/Header.vue";
import apis from "@/services/apis";
import variables from "@/services/variables";
import moment from "moment";

import { auth, fsdb } from "@/firestore";
// import firebase from "firebase/app";
// import "firebase/auth";
// import "firebase/firestore";

export default {
  name: "home",
  components: {
    Header,
  },
  props: ["type"],
  data() {
    return {
      isOpenAll: false,
      showPartnerIdText: false,
      loading: true,
      showSuggestionLink: false,
      showAd: false,
      queryFrom: "portal", // portal || cart
      suggestionLink: {
        portal: {
          path: "/notify",
          img: "/images/line_notify.png",
        },
        line: {
          path: "",
          img: "/images/line_addfriend.png",
        },
        web: {
          path: "",
          img: "/images/line_addfriend.png",
        }
      },
      cssMap: {
        eat_in: "inside",
        delivery: "delivery",
        to_go: "self",
        shipping: "freight",
        direct: "hospital",
      },
      mealTypeMap: {
        eat_in: "內用",
        to_go: "自取",
        delivery: "外送",
        shipping: "宅配",
        direct: "院內送",
      },
      order: { },
      orderQty: 0,
      acceptType: "auto",
      statusSteps: {
        auto: {
          eat_in: ["new", "accepted"],
          to_go: ["new", "accepted"],
          delivery: ["new", "accepted"],
          shipping: ["new"],
          direct: ["new"],
        },
        manual: {
          eat_in: ["new", "accepted", "done"],
          to_go: ["new", "accepted", "done"],
          delivery: ["new", "accepted", "delivering", "done"],
          shipping: ["new"],
          direct: ["new"],
        },
      },
      statusStepMap: {
        auto: {
          new: "new",
          accepted: "accepted",
          done: "accepted",
          lala_assigning_driver: "accepted",
          lala_on_going: "accepted",
          lala_picked_up: "accepted",
          lala_completed: "accepted",
          lala_rejected: "accepted",
          cancelled: "cancelled",
          rejected: "cancelled",
          dispatched: "dispatched",
          shipping: "shipping",
        },
        manual: {
          new: "new",
          accepted: "accepted",
          done: "done",
          lala_assigning_driver: "delivering",
          lala_on_going: "delivering",
          lala_picked_up: "delivering",
          lala_completed: "delivering",
          lala_rejected: "delivering",
          cancelled: "cancelled",
          rejected: "cancelled",
          dispatched: "dispatched",
          shipping: "shipping",
        },
      },
      menuUrl: "",
      webLink: "",
    };
  },
  computed: {
    userId() {
      return localStorage.getItem("lineUserId");
    },
    uuid() {
      return localStorage.getItem("qcsso:uuid");
    },
    variables() {
      return variables;
    },
  },
  methods: {
    openAll() {
      if (this.order.groupOrderData) {
        console.log('openall');
        for (let gOrder of this.order.groupOrderData) {
          gOrder.openDetail = true;
        }
      }
      this.isOpenAll = true;
    },
    closeAll() {
      if (this.order.groupOrderData) {
        console.log('claseall');
        for (let gOrder of this.order.groupOrderData) {
          gOrder.openDetail = false;
        }
      }
      this.isOpenAll = false;
    },
    toggleDetail(gOrder) {
      console.log('switch go ', gOrder);
      if (gOrder) gOrder.openDetail = !gOrder.openDetail;
    },
    gotoPoints(pointVendor, phone) {
      window.location.href = `/accounts/${this.$router.currentRoute.query.s}/${pointVendor}?phone=${phone}`;
    },
    gotoSettings() {
      this.$router.push({
        path: "/settings",
        query: this.$router.currentRoute.query,
      });
    },
    goToPage(link) {
      let self = this;
      if (this.type === "portal") {
        this.$router.push({
          path: self.suggestionLink["portal"].path,
          query: this.$router.currentRoute.query,
        });
      } else {
        window.open(self.suggestionLink["line"].path, "_blank");
      }
    },
    openLink(link) {
      console.log("check liff");
      if (liff && typeof liff.openWindow === "function") {
        console.log("is liff");
        try {
          liff.openWindow({
            url: link,
            external: true,
          });
        } catch (e) {
          console.log(e.stack);
          window.open(link, "_blank");
        }
      } else {
        console.log("no liff");
        window.open(link, "_blank");
      }
    },
    openMenu(orderId) {
      if (orderId) {
        window.location.href =
          this.menuUrl + "&orderId=" + orderId + "&source=order_detail";
      }
    },
  },
  mounted() {
    // 不直接import firestore看看可否避免別的頁面也去連線firestore
    // Get a Firestore instance

    // const fapp = firebase.initializeApp({
    //   projectId: GLOBAL_ENV_FIREBASE_PROJECT_ID,
    //   apiKey: GLOBAL_ENV_FIREBASE_API_KEY,
    //   // apiKey: `${process.env.VUE_APP_FIREBASE_API_KEY}`,
    //   // projectId: `${process.env.VUE_APP_FIREBASE_PROJECT_ID}`
    // });

    // const fsdb = fapp.firestore();
    // const auth = fapp.auth();

    let self = this;

    console.log('check type ' + self.type);
    let queryFun = "getOrderDetailByToken";
    // console.log(JSON.stringify(self.$router.currentRoute.query));
    let authBy = self.$router.currentRoute.query.token;
    if (self.type === "line" && self.$router.currentRoute.query.token) {
      // 要注意這個判斷可能有後遺症...
      queryFun = "getOrderDetailByToken";
      authBy = self.$router.currentRoute.query.token;
      // console.log('query by token');
    } else if (self.userId) {
      if (GLOBAL_ENV_SDKTYPE === "sso") {
        queryFun = "getOrderDetailByUuid";
        authBy = self.uuid;
      } else {
        queryFun = "getOrderDetail";
        authBy = self.userId;
      }

      // console.log('query by user');
    }
    apis[queryFun](authBy, self.$router.currentRoute.params.orderId).then(
      (order) => {
        self.loading = false;
        // console.log(order);
        if (!order) order = {};

        // if (!order.detail) order.detail = {};

        if (order.isManual) self.acceptType = "manual";

        // if (!order.detail.products)
          // order.detail.products = [];
          
        if (order.products) {
          for (let i = 0; i < order.products.length; ++i) {
            this.orderQty += order.products[i].qty;
          }
        }

        if (order.tickets) {
          for (let i = 0; i < order.tickets.length; ++i) {
            this.orderQty += order.tickets[i].qty;
          }
        }

        if (order.shopId) {
          apis.getShopInfo(order.shopId).then(function(shopData) {
            if (shopData) {
              if (GLOBAL_ENV_SDKTYPE === "sso") {
                self.menuUrl = shopData.webLink;
              } else {
                self.menuUrl = shopData.menuUrl;
              }
            }
          });
        }

        // handle retail
        if (order.shopCategory === "retail") {
          switch (order.mealType) {
            case "delivery":
              order.mealType = "shipping";
              break;
            case "to_go":
              order.mealType = "direct";
              break;
            case "eat_in":
              order.mealType = "to_go"; // 零售的自取存到DB是eat_in...
              break;
          }
        }

        order.isPaymentTimeout =
          moment().diff(moment.unix(order.createdTs), "minutes") < 15
            ? false
            : true;

        // order.paymentDue = moment.unix(order.createdTs).add(15, "minutes").format('YYYY-MM-DD HH:mm:ssZ');
        order.paymentDue = moment.unix(order.createdTs).add(15, "minutes").locale("zh-TW").fromNow();

        order.stepStatus =
          self.statusStepMap[self.acceptType][order.orderStatus];

        if (order.lineAddFriendUrl) {
          self.suggestionLink.line.path = order.lineAddFriendUrl;
          self.showSuggestionLink = true;
        } else {
          if (self.type === "line") {
            self.showSuggestionLink = false;
          } else {
            self.showSuggestionLink = true;
          }
        }

        if (order.showAd) {
          self.showAd = order.showAd;
        }

        if (order.groupOrderData) {
          for (let gOrder of order.groupOrderData) {
            gOrder.openDetail = false;
            gOrder.createdTime = moment
              .unix(gOrder.createdTs)
              .format("YYYY-MM-DD HH:mm:ss");
          }
        }
        if (order.pickupTs) {
          order.takeMealTime = moment.unix(order.pickupTs).format('YYYY-MM-DD HH:mm');
          if (order.bufferMinutes) {
            order.takeMealTime += '~' + moment.unix(order.pickupTs).add(order.bufferMinutes, 'minutes').format('HH:mm');
          }
        }
        if (order.createdTs) {
          order.orderTime = moment.unix(order.createdTs).format('YYYY-MM-DD HH:mm');
        }

        if (order.tickets) {

          for (let ticket of order.tickets) {
            let productStr = ticket.name || '';
            if (ticket && ticket.addonDisplay) {
              productStr += `(${ticket.addonDisplay})`
            }
            console.log('debug ticket ' + JSON.stringify(ticket));
            order.products.push({
              name: productStr,
              qty: ticket.qty,
              price: ticket.addonAmount || 0,
              priceStr: '寄杯券折抵'
            })
          }
          
        }

        if (self.type !== "line") self.showSuggestionLink = false;

        console.log("the order response " + JSON.stringify(order));

        // gtm debug ----
        window.dataLayer = window.dataLayer || []

        let gtmProducts = [];
        if (order.orderSnapshot) {
          for (let p of order.orderSnapshot.cartProducts) {
            gtmProducts.push({
              // 'sku': p.id,
              // 'name': p.productName,
              // 'category': '',
              // 'price': p.productAmount,
              // 'quantity': p.qty
              'item_id': p.id,
              'item_name': p.productName,
              'item_category': '',
              'item_brand': '',
              'price': p.productAmount.toString(),
              'quantity': p.qty
            })
          }
        }
       
        dataLayer.push({
          event: "purchase",
          ecommerce: {
            // purchase: {
              transaction_id: order.orderId,
              affiliation: order.shopName,
              value: (order.orderAmount ? order.orderAmount.toString() : "0"),
              tax: "0",
              shipping: (order.deliveryFee ? order.deliveryFee.toString() : "0"),
              currency: "TWD",
              // currency: "NTD",
              coupon: "",
              // items: gtmProducts
              // [{
              //   item_name: "Triblend Android T-Shirt",
              //   item_id: "12345",
              //   price: "15.25",
              //   item_brand: "Google",
              //   item_category: "Apparel",
              //   item_variant: "Gray",
              //   quantity: 1
              // }, {
              //   item_name: "Donut Friday Scented T-Shirt",
              //   item_id: "67890",
              //   price: 33.75,
              //   item_brand: "Google",
              //   item_category: "Apparel",
              //   item_variant: "Black",
              //   quantity: 1
              // }]
            // }
          },
          items: gtmProducts
          // 'transactionId': order.orderId,
          // 'transactionAffiliation': order.shopName,
          // 'transactionTotal': order.orderAmount || 0,
          // 'transactionTax': 0,
          // 'transactionShipping': order.deliveryFee || 0,
          // 'transactionProducts': gtmProducts
        });
        // gtm debug end ----

        self.order = order;

        // console.log(order);
        // firebase test
        auth.signInAnonymously().catch(function(error) {
          // Handle Errors here.
          var errorCode = error.code;
          var errorMessage = error.message;
          console.log("firebase error ", error);
          // ...
        });

        auth.onAuthStateChanged(function(user) {
          if (user) {
            // User is signed in.
            var isAnonymous = user.isAnonymous;
            var uid = user.uid;
            // fsdb.collection('shops').doc(`${self.order.shopId}/orders/${self.order.id}`).get()
            // .then(doc => {
            //   console.log(JSON.stringify(doc.data()));
            // })
            // fsdb.doc(`shops/${self.order.shopId}/orders/${self.order.id}`).get()
            //  .then(doc => {
            //   console.log('doc2 ' + JSON.stringify(doc.data()));

            // })

            console.log("f connect " + self.order.shopId + " " + self.order.id);
            fsdb
              .doc(`shops/${self.order.shopId}/orders/${self.order.id}`)
              .onSnapshot((doc) => {
                let tmp = doc.data();
                console.log("update order ", JSON.stringify(self.order));
                console.log("doc " + JSON.stringify(tmp));

                if (tmp) {
                  self.order.orderStatus = tmp.status;
                  self.order.paymentStatus = tmp.paymentStatus; // 付款失敗不要轉轉轉
                  
                  self.order.isCancelled = tmp.is_cancelled ? 1 : 0;
                  self.order.isConfirmed = tmp.is_confirmed ? 1 : 0;
                  self.order.stepStatus =
                    self.statusStepMap[self.acceptType][order.orderStatus];
                }
              });
          } else {
            // User is signed out.
            // ...
          }
          // ...
        });
      }
    );
  },
};
</script>

<style scoped>
.to_bottom {
  bottom: 0px;
}
/* @import '../assets/css/theme_default.css'; */
</style>
